<template>
  <div style="height: 100%">
    <div class="top">
      <div>
        <div>
          <p class="p1">登记车辆</p>
          <p class="p2">{{stallCount || 0}}辆</p>
        </div>
        <div><img style="width: 50px;height: 50px" src="../../../../assets/image/new/register.png"></div>
      </div>
      <div>
        <div>
          <p class="p1">今日已出场</p>
          <p class="p2">{{carNum.CarOut || 0}}辆</p>
        </div>
        <div><img style="width: 50px;height: 50px" src="../../../../assets/image/new/car.png"></div>
      </div>
      <div>
        <div>
          <p class="p1">今日已进场</p>
          <p class="p2">{{carNum.CarIn || 0}}辆</p>
        </div>
        <div><img style="width: 50px;height: 50px" src="../../../../assets/image/new/car-left.png"></div>
      </div>
      <div>
        <div>
          <p class="p1">今日临时车辆</p>
          <p class="p2">{{outCarCount || 0}}辆</p>
        </div>
        <div><img style="width: 50px;height: 50px" src="../../../../assets/image/new/short-time-car.png"></div>
      </div>
      <div>
        <div>
          <p class="p1">今日已出场</p>
          <p class="p2">{{carNum.tempCarOut || 0}}辆</p>
        </div>
        <div><img style="width: 50px;height: 50px" src="../../../../assets/image/new/car.png"></div>
      </div>
      <div>
        <div>
          <p class="p1">今日已进场</p>
          <p class="p2">{{carNum.tempCarIn || 0}}辆</p>
        </div>
        <div><img style="width: 50px;height: 50px" src="../../../../assets/image/new/car-left.png"></div>
      </div>
    </div>
    <div class="main">
      <div class="title">近七日进出场统计</div>
      <div id="chart" style="width: 88vw;height: calc(100% - 57px);"></div>
    </div>
  </div>
</template>

<script>
  import base from '../../../../untils/base'
  import myHttp from '../../../../untils/port'
  import util from '../../../../untils/util'
  export default {
    data() {
      return {
        projectId: '',
        allCarCount: '',
        freePosition: '',
        outCarCount: '',
        stallCount: '',
        carCount: [],
        carNum:{}
      }
    },
    created() {
      this.projectId = util.session.get('groupId')
      this.getData()
      this.getNum()
    },
    mounted() {
      this.initChart()
    },
    methods: {
      // secStallByCommunityId
      getData() {
        var that = this
        myHttp
          .selectProjectCarCount({
            projectId: this.projectId
          })
          .then(
            function(resp) {
              if (resp.data.code == '200') {
                console.log(resp)
                that.outCarCount = resp.data.data.tempCarCount
                that.stallCount = resp.data.data.carCount
              } else {
                that.$message.error(resp.data.msg)
              }
            },
            function() {}
          )
      },
      // selectNowCarInOutInfo
      getNum() {
        var that = this
        myHttp
          .selectNowCarInOutInfo({
            projectId: this.projectId
          })
          .then(
            function(resp) {
              if (resp.data.code == '200') {
                // console.log(resp)
                // carAll:resp.data
                that.carNum = resp.data.data
              } else {
                that.$message.error(resp.data.msg)
              }
            },
            function() {}
          )
      },


      initChart(){
        let chart = this.$echarts.init(document.querySelector('#chart'))
        chart.setOption({
           grid: {      //  设置位置
            top: '5%',
            left: '5%',
            right: '10%',
            bottom: '8%',
          },
          legend: {
            right: 0,
            bottom: '7%',
            orient: 'vertical',
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: ['06-26','06-27','06-28','06-29','06-30','07-01','07-02'],
            axisTick: {
              show: false   // x轴的刻度
            },
            axisLabel: {   // x轴文字的配置
              textStyle: {  
                color: '#9E9E9E',
                fontSize: '14px'
              }
            },
            axisLine: {
              lineStyle: {        //自定义x轴线的颜色和阴影
                color: '#165EDD',
                shadowColor: '#0F9FED',
                shadowBlur: 6,
                width: 2
              }
            },
            splitLine: {   // x轴背景线条的配置
              show: true,
              lineStyle: {
                color: '#739FED',
                type: 'dashed'
              }
            }
          },
          yAxis: {
            axisLabel: {     // y轴文字的配置
              textStyle: {
                color: '#9E9E9E',
                fontSize: '14px'
              }
            },
            axisLine: {
              show: true,    // 打开y轴刻度线
              lineStyle: {
                color: '#165EDD',
                width: 2,
                type: 'solid',
                shadowColor: '#0F9FED',
                shadowBlur: 6,
              }
            },
            splitLine: {     // y轴背景线条的配置
              show: true,
              lineStyle: {
                color: '#739FED',
                type: 'dashed'
              }
            },
          },
          tooltip: {   // 提示框
            trigger: 'axis',
            position: 'top',    // 提示框在顶部
            borderColor: '#739FED',    //  提示框的边框颜色
            axisPointer: {
              type: 'cross'
            }
          },
          series: [{
            type: 'line',
            name: '注册进场',
            color: '#32BD0C',
            smooth: true,
            data: [15,10,32,10,21,50,28],
            // itemStyle: {
            //   normal: {
            //     color: new this.$echarts.graphic.LinearGradient(0,1,0,0,
            //     [{
            //       offset: 0,
            //       color: '#D8D8D8'
            //     },{
            //       offset: 1,
            //       color: '#0FA2F1'
            //     }]
            //     )
            //   }
            // }
          },
          {
            type: 'line',
            name: '注册出场',
            color: '#38D0E2',
            smooth: true,
            data: [20,10,42,32,12,14,52],
          },
          {
            type: 'line',
            name: '临时进场',
            color: '#EE8625',
            smooth: true,
            data: [5,40,12,12,45,25,32],
          },
          {
            type: 'line',
            name: '临时出场',
            color: '#22A8F1',
            smooth: true,
            data: [13,12,25,36,56,25, 5],
          }
          ]
        })
      }
    },
  }
</script>

<style scoped>
.p1{
  font-size: 16px;
  color: #fff;
  line-height: 32px;
}
.p2{
  font-size: 24px;
  font-weight: 900;
  color: #fff;
  text-align: left;
}
.top{
  display: flex;
  justify-content: space-between;
  padding-top: 16px;
  margin-bottom: 16px
}
.top > div{
  height: 150px;
  border-radius: 6px;
  width: 16%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1.2vw;
  /* background-image: ; */
}
.top > div:nth-child(1){
  background: url('../../../../assets/image/new/car-bg.png') no-repeat center 44px ,linear-gradient(277deg, #4D6EB1 2%, #4D6EB1 5%, #8AABEF 50%, #C2D6FF 97%, #C2D6FF 97%);
  box-shadow: 2px 2px 6px 0px rgba(77, 110, 177, 0.6);
}
.top > div:nth-child(2){
  background: url('../../../../assets/image/new/car-bg.png') no-repeat center 44px , linear-gradient(277deg, #33CFE1 2%, #33CFE1 5%, #6AD7EB 47%, #98F5FF 97%, #98F5FF 97%);
  box-shadow: 2px 2px 6px 0px rgba(54, 207, 226, 0.6);
}
.top > div:nth-child(3){
  background: url('../../../../assets/image/new/car-bg.png') no-repeat center 44px , linear-gradient(277deg, #2FBB09 2%, #2FBB09 6%, #57DB37 47%, #AAFF94 97%, #AAFF94 97%);
  box-shadow: 2px 2px 6px 0px rgba(48, 188, 10, 0.6);
}
.top > div:nth-child(4){
  background: url('../../../../assets/image/new/car-bg.png') no-repeat center 44px , linear-gradient(277deg, #F28B89 2%, #F28B89 3%, #F6AE78 47%, #F8D45F 97%, #F8D45F 97%);
  box-shadow: 2px 2px 6px 0px rgba(242, 142, 136, 0.6);
}
.top > div:nth-child(5){
  background: url('../../../../assets/image/new/car-bg.png') no-repeat center 44px , linear-gradient(277deg, #22A8F1 2%, #22A8F1 6%, #22A8F0 47%, #55C3FF 97%, #55C3FF 97%);
  box-shadow: 2px 2px 6px 0px rgba(34, 168, 241, 0.6);
}
.top > div:nth-child(6){
  background: url('../../../../assets/image/new/car-bg.png') no-repeat center 44px , linear-gradient(277deg, #F18622 2%, #F18622 6%, #CC8C46 44%, #BA9462 97%, #BA9462 97%);
  box-shadow: 2px 2px 6px 0px rgba(241, 134, 34, 0.6);
}
.main{
  height: calc(100% - 182px);
  border-radius: 6px;
  background: #FFFFFF;
  box-shadow: 0px 4px 10px 0px rgba(77, 110, 177, 0.3);
}
.title{
  padding: 17px;
  font-size: 16px;
  color: #666666;
  text-align: left;
  border-bottom: 2px solid #E7E7E7;
}
</style>